export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

import {bind, Message} from 'kpc';

export default class extends Component {
    static template = template;
    static defaults() {
        return {
            currentStep: 0,
            showTour: false,
            inputValue: '',
            errorMsg: '',
            tourData: [
                {
                    target: '#step1',
                    title: '第一步',
                    content: '这是第一步的引导说明',
                    position: 'bottom'
                },
                {
                    target: '#step2',
                    title: '第二步',
                    content: '这是第二步的引导说明',
                    position: 'right'
                },
                {
                    target: '.step3-input',
                    title: '第三步',
                    content: '请在输入框中输入"next"以继续',
                    position: 'bottom'
                },
                {
                    target: '#step4',
                    title: '最后一步',
                    content: '恭喜您完成了所有步骤',
                    position: 'top'
                }
            ]
        };
    }

    @bind
    startTour() {
        this.set({
            showTour: true,
            currentStep: 0,
        });
    }

    @bind
    finishTour() {
        this.set({
            showTour: false
        });
    }
    

    @bind
    handleBeforeChange(current: number) {
        const inputValue = this.get('inputValue') as string;
        if (current === 3) {
            if (inputValue !== 'next') {
                Message.error('请在输入框中输入"next"才能进入下一步');
                return false;
            }
        }
        return true;
    }
}